import React from 'react';
import { Text, Inline } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { FilterGroupProps } from './types';

export const ITEM_COUNTS_LIMIT = 2;

// General filter group component
export default function FilterGroup({ title, truncateMessageKey, items }: FilterGroupProps) {
	const intl = useIntl();
	let remainderItemCounts = items.length - ITEM_COUNTS_LIMIT;
	// if the remainder item count is 1, might as well display the last item
	remainderItemCounts = remainderItemCounts === 1 ? 0 : remainderItemCounts;
	const truncatedItems =
		remainderItemCounts > 0 ? items.slice(0, items.length - remainderItemCounts) : items;

	if (fg('replace_typography_css_with_tokens_arj')) {
		return (
			<>
				<Text as="strong">{title}</Text>
				<Inline alignBlock="center" space="space.050">
					{truncatedItems.map((item, i) => (
						<span key={i}>
							{i === 0 ? '(' : ''}
							{item}
							{i < truncatedItems.length - 1 || remainderItemCounts > 0 ? ', ' : ')'}
						</span>
					))}
					{remainderItemCounts > 0 ? (
						<span>{intl.formatMessage(truncateMessageKey, { count: remainderItemCounts })})</span>
					) : (
						''
					)}
				</Inline>
			</>
		);
	}
	return (
		<>
			{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
			<strong>{title} </strong>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<span className={styles.filterGroupItems}>
				{truncatedItems.map((item, i) => (
					<span key={i}>
						{i === 0 ? '(' : ''}
						{item}
						{i < truncatedItems.length - 1 || remainderItemCounts > 0 ? ', ' : ')'}
					</span>
				))}
				{remainderItemCounts > 0 ? (
					<span>{intl.formatMessage(truncateMessageKey, { count: remainderItemCounts })})</span>
				) : (
					''
				)}
			</span>
		</>
	);
}
